export default __webpack_public_path__ + "static/media/guepard.7cc131ac.svg";